import { render, staticRenderFns } from "./SPetshopCarteiraDigital.vue?vue&type=template&id=0bbbb28d&scoped=true"
import script from "./SPetshopCarteiraDigital.vue?vue&type=script&lang=js"
export * from "./SPetshopCarteiraDigital.vue?vue&type=script&lang=js"
import style0 from "./SPetshopCarteiraDigital.vue?vue&type=style&index=0&id=0bbbb28d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbb28d",
  null
  
)

export default component.exports